import React from 'react';
import { TherapyAddressImage } from '../../containers/TherapistProfile/Tabs';
import { sanitiseHTML } from 'src/legacy/utils/helpers';
import './EventDetailTooltip.scss';

interface Prop {
  appointmentLocation: any;
}

const EventTooltipAddressContainer: React.FC<Prop> = ({ appointmentLocation }) => {
  return (
    <div className='d-flex mt-1'>
      <div>
        <TherapyAddressImage
          id={appointmentLocation?.img}
          isAppointmentLocation={true}
          officeImageUrl={appointmentLocation?.officeImage}
        />
      </div>
      <div className='appointmentLocation-in-person-ofc-address'>
        {appointmentLocation?.addressInfo1 && (
          <p>{sanitiseHTML(appointmentLocation?.addressInfo1)}</p>
        )}
        {appointmentLocation?.addressInfo2 && (
          <p>{sanitiseHTML(appointmentLocation?.addressInfo2)}</p>
        )}
        {appointmentLocation?.addressInfo3 && (
          <p>{sanitiseHTML(appointmentLocation?.addressInfo3)}</p>
        )}
        {appointmentLocation?.addressInfo4 && (
          <p>{sanitiseHTML(appointmentLocation?.addressInfo4)}</p>
        )}
      </div>
    </div>
  );
};

export default EventTooltipAddressContainer;